import { endpoints } from '../../Constants';
// eslint-disable-next-line object-curly-newline
import { authHeader, toQueryStringURL } from '../../Helpers';
import handleResponse from '../helpers';

const menuServices = {
	gateway,
	createMenu,
	viewMenu,
	patchMenu,
};

function gateway({ req, method }) {
	switch (method) {
		case 'CREATE':
			return createMenu({
				req,
			});
		case 'VIEW':
			return viewMenu({
				req,
			});
		case 'LIST':
			return listMenu({
				req,
			});
		case 'UPDATE':
			return updateMenu({
				req,
			});
		case 'PATCH':
			return patchMenu({
				req,
			});
		default:
			break;
	}
	return new Promise();
}

function createMenu({ req }) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(endpoints.MENU, requestOptions).then(handleResponse);
}
function patchMenu({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.MENU, params);

	const requestOptions = {
		method: 'PATCH',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function updateMenu({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.MENU, params);

	const requestOptions = {
		method: 'PUT',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function viewMenu({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.MENU, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function listMenu({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.MENU, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

export default menuServices;
